import { UserDoc, UserWhole } from 'lib/interfaces/database/user';
import _ from 'lodash';
import { DealersService } from 'services/dealers';
import { create } from 'zustand';

interface State {
  // only users that are dealers will be loaded
  data: UserWhole[];
}

interface Actions {
  readonly load: (force?: boolean) => void;
  readonly create: (v: Partial<UserDoc>) => Promise<boolean>;
  readonly update: (id: string, v: Partial<UserDoc>) => Promise<boolean>;
}

interface Store extends State, Actions {}

const useDealersStore = create<Store>((set, get) => {
  const service = DealersService.getInstance();

  return {
    data: [],

    load: async (force) => {
      if (!force && get().data.length > 0) {
        console.debug('Skipped unforced load');
        return;
      }

      const results = await service.getAll();

      if (results) {
        set({ data: results });
      }
    },

    create: async (v) => {
      if (!v.id) {
        console.error('Cannot create a dealer without a user ID');
        return false;
      }

      const record = await service.create(v.id, {});

      if (record) {
        const nextData = _.clone(get().data);
        nextData.push(record);

        set({ data: nextData });
      }

      return !!record;
    },

    update: async (id, v) => {
      const record = await service.update(id, v);

      if (record) {
        const nextData = get().data.map((d) =>
          d.id === record.id ? record : d
        );

        set({ data: nextData });
      }

      return !!record;
    },
  };
});

export default useDealersStore;
